import { render, staticRenderFns } from "./AppSidenav.vue?vue&type=template&id=6657e2d7&scoped=true&"
import script from "./AppSidenav.vue?vue&type=script&lang=js&"
export * from "./AppSidenav.vue?vue&type=script&lang=js&"
import style0 from "./AppSidenav.vue?vue&type=style&index=0&id=6657e2d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6657e2d7",
  null
  
)

export default component.exports